import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";

export const fetchDashboardStats = createAsyncThunk(
  "fetchDashboardStats",
  async (practiceId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/stats`
      // `${baseUrl}api/practices/NQIVGTLO01813917/stats`
    );
    return result;
  }
);

export const fetchDashboardDetails = createAsyncThunk(
  "fetchDashboardDetails",
  async (practiceId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}?view=extended`
      // `${baseUrl}api/practices/NQIVGTLO01813917?view=extended`
    );
    return result;
  }
);
